export default __webpack_public_path__ + "icon5f49e7d.svg";